import { F as e, L as t, h as n, i as r, m as i, ot as a, p as o, t as s, v as c, w as l } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as u } from "./i18n-lite-BcmwMblk.js";
import { r as d, t as f } from "./normalize-props-DNjMoRjC.js";
//#region src/webcomponents/pix-article/locales/de-AT.json
var p = {}, m = {}, h = {}, g = {}, _ = { "pix-article": { byAuthor: "Par {{author}}" } }, v = { "pix-article": { byAuthor: "Par {{author}}" } }, y = {}, b = {}, x = ["aria-level"], S = { class: "article__metadata" }, C = { class: "article__author" }, w = ["innerHTML"], T = /*#__PURE__*/ s(/* @__PURE__ */ l({
	__name: "PixArticle.ce",
	props: {
		titleLevel: {
			default: 2,
			type: Number
		},
		articleTitle: { type: String },
		author: { type: String },
		date: { type: String },
		paragraphs: { type: Array },
		highlightedSentence: { type: String },
		colorOfHighlightSentence: { type: String }
	},
	setup(r) {
		let s = i(() => r.highlightedSentence ? r.paragraphs.map((e) => e.replace("{{highlightedSentence}}", `<strong style="color: ${r.colorOfHighlightSentence};">${r.highlightedSentence}</strong>`)) : r.paragraphs);
		return (i, l) => (e(), c(o, null, [
			n("div", {
				class: "article__title",
				role: "heading",
				"aria-level": r.titleLevel
			}, a(r.articleTitle), 9, x),
			n("p", S, [n("span", C, a(i.$t("pix-article.byAuthor", { author: r.author })), 1), n("time", null, a(r.date), 1)]),
			(e(!0), c(o, null, t(s.value, (t, n) => (e(), c("p", {
				key: n,
				innerHTML: t
			}, null, 8, w))), 128))
		], 64));
	}
}), [["styles", ["[data-v-e971f15a]{--pix-neutral-800:#253858;color:var(--pix-neutral-800);font-family:Nunito,Roboto,sans-serif}.article__title[data-v-e971f15a]{font-size:1.3rem;font-weight:700}.article__metadata[data-v-e971f15a]{font-style:italic}.article__author[data-v-e971f15a]{border-right:solid 1px var(--pix-neutral-800);margin-right:.5rem;padding-right:.7rem}"]], ["__scopeId", "data-v-e971f15a"]]);
//#endregion
//#region src/webcomponents/pix-article/pix-article.ce.js
u.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": p,
	"./locales/en.json": m,
	"./locales/es-419.json": h,
	"./locales/es.json": g,
	"./locales/fr-BE.json": _,
	"./locales/fr.json": v,
	"./locales/it.json": y,
	"./locales/nl.json": b
}));
var E = r(T, { configureApp(e) {
	u.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(u);
} });
E.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: f(e.titleLevel),
	highlightedSentence: d(e.highlightedSentence),
	colorOfHighlightSentence: d(e.colorOfHighlightSentence)
}), window.customElements.define("pix-article", E);
//#endregion
